import { Apartment } from '../types/Apartment';
import { generateBuilding360Images, generateBuilding360RealImages } from '../firebase/utils';
import { generateFloorPlanImages } from '../firebase/utils';

const cloudfrontUrl = 'https://d2tbav89ixiad0.cloudfront.net';

// Neue Profilbild-URLs entsprechend der Zuordnung A1=1.jpg, B1=2.jpg, A2=3.jpg, B2=4.jpg etc.
const profileImages = [
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f113d850e99612050a40_1.jpg', // A1
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f113fe99593508f25f01_2.jpg', // B1
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f113be99d7ba07271222_3.jpg', // A2
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f113cb56ce5a1ea00a74_4.jpg', // B2
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1127081ec278633b0d1_5.jpg', // A3
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1130842b3ce678a6aff_6.jpg', // B3
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f113253078ca0c887b44_7.jpg', // A4
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f113105219c626276dbb_8.jpg', // B4
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f114a76e2babd6225bb5_9.jpg', // A5
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f114826db4c61ccc7757_10.jpg', // B5
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1149297eaa439e39c8b_11.jpg', // A6
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f115173cbb20c2b99df6_12.jpg', // B6
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f115c00d6d6ea04f3625_13.jpg', // A7
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f11545c2037da5040d9e_14.jpg', // B7
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f115173cbb20c2b99dfb_15.jpg', // A8
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1156fdff45c98ce10b5_16.jpg', // B8
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1166014e8629720934c_17.jpg', // A9
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f11624ae8991696c39c4_18.jpg', // B9
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f11628e1e50ce76e51c2_19.jpg', // A10
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f117fe99593508f25f55_20.jpg', // B10
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1174c79d5e6134fcca4_21.jpg', // A11
  'https://cdn.prod.website-files.com/685d2a1749025f45e74d4e97/6886f1137418f1dd3e570f09_22.jpg'  // B11
];

// Funktion um das richtige Profilbild basierend auf der Apartment ID zu erhalten
const getProfileImage = (apartmentId: number): string => {
  // A-Wohnungen (ungerade Indizes): ID 1=Index 0, ID 2=Index 2, ID 3=Index 4, etc.
  // B-Wohnungen (gerade Indizes): ID 12=Index 1, ID 13=Index 3, ID 14=Index 5, etc.
  if (apartmentId <= 11) {
    // Haus A: A1=0, A2=2, A3=4, etc.
    return profileImages[(apartmentId - 1) * 2];
  } else {
    // Haus B: B1=1, B2=3, B3=5, etc.
    return profileImages[((apartmentId - 12) * 2) + 1];
  }
};

// Funktion um den neuen PDF-Namen zu generieren (z.B. "Wohnung A1.1" für ID 1)
export const getApartmentPDFName = (apartmentId: number): string => {
  const mapping: { [key: number]: string } = {
    1: 'Wohnung A1.1',
    2: 'Wohnung A1.3',
    3: 'Wohnung A1.2',
    4: 'Wohnung A2.1',
    5: 'Wohnung A2.3',
    6: 'Wohnung A2.2',
    7: 'Wohnung A3.1',
    8: 'Wohnung A3.3',
    9: 'Wohnung A3.2',
    10: 'Wohnung A4.1',
    11: 'Wohnung A4.2',
    12: 'Wohnung B1.1',
    13: 'Wohnung B1.3',
    14: 'Wohnung B1.2',
    15: 'Wohnung B2.1',
    16: 'Wohnung B2.3',
    17: 'Wohnung B2.2',
    18: 'Wohnung B3.1',
    19: 'Wohnung B3.3',
    20: 'Wohnung B3.2',
    21: 'Wohnung B4.1',
    22: 'Wohnung B4.2'
  };
  return mapping[apartmentId] || `Wohnung A${apartmentId}`;
};



// Die 360°-Bilder einmal generieren, da sie für alle Wohnungen gleich sind.
export const buildingImages = generateBuilding360Images();

// Die realen 360°-Bilder einmal generieren (25 Bilder)
export const buildingRealImages = generateBuilding360RealImages();

/**
 * Die Liste der 22 Wohnungen basierend auf den bereitgestellten Informationen.
 * Die Vorschaubilder (thumbnails) werden aus dem Ordner '22-Wohneinheiten-Karte' geladen.
 * Die Dateinamen werden an das Schema 'Wohnung_1.webp', 'Wohnung_2.webp', etc. angepasst.
 * Die Grundrisse werden aus dem Ordner 'Grundrisse' geladen.
 */
export const apartments: Apartment[] = [
  // HAUS A - Erdgeschoss
  {
    id: 1,
    name: "Wohnung A 1.1 - Süd",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1180000,
    size: 111,
    rooms: 4.5,
    floor: 0,
    description: "Großzügige 4.5-Zimmer-Wohnung im Erdgeschoss mit Südausrichtung. Mit gedecktem Sitzplatz von 14m².",
    features: ["Südausrichtung", "Gedeckter Sitzplatz", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(1),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A1.1.pdf`,
    status: "available", // Explicitly set status for testing
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(1)
  },
  {
    id: 2,
    name: "Wohnung A 1.3 - Nord",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1190000,
    size: 106,
    rooms: 4.5,
    floor: 0,
    description: "4.5-Zimmer-Wohnung im Erdgeschoss mit Nordausrichtung. Mit gedecktem Sitzplatz von 14m².",
    features: ["Nordausrichtung", "Gedeckter Sitzplatz", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(2),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A1.3.pdf`,
    status: "reserved", // Set as reserved for testing
    available: false,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(2)
  },
  {
    id: 3,
    name: "Wohnung A 1.2 - Ost/Mitte",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 720000,
    size: 63,
    rooms: 2.5,
    floor: 0,
    description: "Kompakte 2.5-Zimmer-Wohnung im Erdgeschoss mit Ost-/Mittelausrichtung. Mit gedecktem Sitzplatz von 14m².",
    features: ["Ost-/Mittelausrichtung", "Gedeckter Sitzplatz", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(3),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A1.2.pdf`,
    status: "sold", // Set as sold for testing
    available: false,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(3)
  },

  // HAUS A - 1. Obergeschoss
  {
    id: 4,
    name: "Wohnung A 2.1 - Süd",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1160000,
    size: 111,
    rooms: 4.5,
    floor: 1,
    description: "Großzügige 4.5-Zimmer-Wohnung im 1. Obergeschoss mit Südausrichtung. Mit gedecktem Balkon von 14m².",
    features: ["Südausrichtung", "Gedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(4),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A2.1.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(4)
  },
  {
    id: 5,
    name: "Wohnung A 2.3 - Nord",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1170000,
    size: 106,
    rooms: 4.5,
    floor: 1,
    description: "4.5-Zimmer-Wohnung im 1. Obergeschoss mit Nordausrichtung. Mit gedecktem Balkon von 14m².",
    features: ["Nordausrichtung", "Gedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(5),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A2.3.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(5)
  },
  {
    id: 6,
    name: "Wohnung A 2.2 - Ost/Mitte",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 740000,
    size: 63,
    rooms: 2.5,
    floor: 1,
    description: "Kompakte 2.5-Zimmer-Wohnung im 1. Obergeschoss mit Ost-/Mittelausrichtung. Mit gedecktem Balkon von 14m².",
    features: ["Ost-/Mittelausrichtung", "Gedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(6),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A2.2.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(6)
  },

  // HAUS A - 2. Obergeschoss
  {
    id: 7,
    name: "Wohnung A 3.1 - Süd",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1185000,
    size: 111,
    rooms: 4.5,
    floor: 2,
    description: "Großzügige 4.5-Zimmer-Wohnung im 2. Obergeschoss mit Südausrichtung. Mit teilgedecktem Balkon von 14m².",
    features: ["Südausrichtung", "Teilgedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(7),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A3.1.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(7)
  },
  {
    id: 8,
    name: "Wohnung A 3.3 - Nord",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1195000,
    size: 106,
    rooms: 4.5,
    floor: 2,
    description: "4.5-Zimmer-Wohnung im 2. Obergeschoss mit Nordausrichtung. Mit teilgedecktem Balkon von 14m².",
    features: ["Nordausrichtung", "Teilgedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(8),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A3.3.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(8)
  },
  {
    id: 9,
    name: "Wohnung A 3.2 - Ost/Mitte",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 750000,
    size: 63,
    rooms: 2.5,
    floor: 2,
    description: "Kompakte 2.5-Zimmer-Wohnung im 2. Obergeschoss mit Ost-/Mittelausrichtung. Mit teilgedecktem Balkon von 14m².",
    features: ["Ost-/Mittelausrichtung", "Teilgedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(9),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A3.2.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(9)
  },

  // HAUS A - Dachgeschoss (Attika)
  {
    id: 10,
    name: "Wohnung A 4.1 - Süd",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1330000,
    size: 104,
    rooms: 3.5,
    floor: 3,
    description: "Exklusive 3.5-Zimmer-Wohnung im Attikageschoss mit Südausrichtung. Mit großer Terrasse von 43m².",
    features: ["Südausrichtung", "Terrasse 43m²", "Tiefgarage", "Aufzug", "Glasfaser", "Attika"],
    images360: buildingImages,
    thumbnail: getProfileImage(10),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A4.1.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(10)
  },
  {
    id: 11,
    name: "Wohnung A 4.2 - Nord",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1410000,
    size: 113,
    rooms: 4.5,
    floor: 3,
    description: "Großzügige 4.5-Zimmer-Wohnung im Attikageschoss mit Nordausrichtung. Mit großer Terrasse von 43m².",
    features: ["Nordausrichtung", "Terrasse 43m²", "Tiefgarage", "Aufzug", "Glasfaser", "Attika"],
    images360: buildingImages,
    thumbnail: getProfileImage(11),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung A4.2.pdf`,
    available: true,
    constructionYear: "Frühjahr 2028",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(11)
  },

  // HAUS B - Erdgeschoss
  {
    id: 12,
    name: "Wohnung B 1.1 - West",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1170000,
    size: 111,
    rooms: 4.5,
    floor: 0,
    description: "Großzügige 4.5-Zimmer-Wohnung im Erdgeschoss mit Westausrichtung. Mit gedecktem Sitzplatz von 14m².",
    features: ["Westausrichtung", "Gedeckter Sitzplatz", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(12),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B1.1.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(12)
  },
  {
    id: 13,
    name: "Wohnung B 1.3 - Ost",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1780000,
    size: 106,
    rooms: 4.5,
    floor: 0,
    description: "4.5-Zimmer-Wohnung im Erdgeschoss mit Ostausrichtung. Mit gedecktem Sitzplatz von 14m².",
    features: ["Ostausrichtung", "Gedeckter Sitzplatz", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(13),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B1.3.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(13)
  },
  {
    id: 14,
    name: "Wohnung B 1.2 - Süd/Mitte",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 710000,
    size: 63,
    rooms: 2.5,
    floor: 0,
    description: "Kompakte 2.5-Zimmer-Wohnung im Erdgeschoss mit Süd-/Mittelausrichtung. Mit gedecktem Sitzplatz von 14m².",
    features: ["Süd-/Mittelausrichtung", "Gedeckter Sitzplatz", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(14),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B1.2.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(14)
  },

  // HAUS B - 1. Obergeschoss
  {
    id: 15,
    name: "Wohnung B 2.1 - West",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1150000,
    size: 111,
    rooms: 4.5,
    floor: 1,
    description: "Großzügige 4.5-Zimmer-Wohnung im 1. Obergeschoss mit Westausrichtung. Mit gedecktem Balkon von 14m².",
    features: ["Westausrichtung", "Gedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(15),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B2.1.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(15)
  },
  {
    id: 16,
    name: "Wohnung B 2.3 - Ost",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1160000,
    size: 106,
    rooms: 4.5,
    floor: 1,
    description: "4.5-Zimmer-Wohnung im 1. Obergeschoss mit Ostausrichtung. Mit gedecktem Balkon von 14m².",
    features: ["Ostausrichtung", "Gedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(16),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B2.3.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(16)
  },
  {
    id: 17,
    name: "Wohnung B 2.2 - Süd/Mitte",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 730000,
    size: 63,
    rooms: 2.5,
    floor: 1,
    description: "Kompakte 2.5-Zimmer-Wohnung im 1. Obergeschoss mit Süd-/Mittelausrichtung. Mit gedecktem Balkon von 14m².",
    features: ["Süd-/Mittelausrichtung", "Gedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(17),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B2.2.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(17)
  },

  // HAUS B - 2. Obergeschoss
  {
    id: 18,
    name: "Wohnung B 3.1 - West",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1175000,
    size: 111,
    rooms: 4.5,
    floor: 2,
    description: "Großzügige 4.5-Zimmer-Wohnung im 2. Obergeschoss mit Westausrichtung. Mit teilgedecktem Balkon von 14m².",
    features: ["Westausrichtung", "Teilgedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(18),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B3.1.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(18)
  },
  {
    id: 19,
    name: "Wohnung B 3.3 - Ost",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1185000,
    size: 106,
    rooms: 4.5,
    floor: 2,
    description: "4.5-Zimmer-Wohnung im 2. Obergeschoss mit Ostausrichtung. Mit teilgedecktem Balkon von 14m².",
    features: ["Ostausrichtung", "Teilgedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(19),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B3.3.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(19)
  },
  {
    id: 20,
    name: "Wohnung B 3.2 - Süd/Mitte",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 740000,
    size: 63,
    rooms: 2.5,
    floor: 2,
    description: "Kompakte 2.5-Zimmer-Wohnung im 2. Obergeschoss mit Süd-/Mittelausrichtung. Mit teilgedecktem Balkon von 14m².",
    features: ["Süd-/Mittelausrichtung", "Teilgedeckter Balkon", "Tiefgarage", "Aufzug", "Glasfaser"],
    images360: buildingImages,
    thumbnail: getProfileImage(20),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B3.2.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: true,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(20)
  },

  // HAUS B - Dachgeschoss (Attika)
  {
    id: 21,
    name: "Wohnung B 4.1 - West",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1320000,
    size: 104,
    rooms: 3.5,
    floor: 3,
    description: "Exklusive 3.5-Zimmer-Wohnung im Attikageschoss mit Westausrichtung. Mit großer Terrasse von 43m².",
    features: ["Westausrichtung", "Terrasse 43m²", "Tiefgarage", "Aufzug", "Glasfaser", "Attika"],
    images360: buildingImages,
    thumbnail: getProfileImage(21),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B4.1.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(21)
  },
  {
    id: 22,
    name: "Wohnung B 4.2 - Ost",
    address: "Zürichstrasse 50, 8340 Hinwil",
    price: 1400000,
    size: 113,
    rooms: 4.5,
    floor: 3,
    description: "Großzügige 4.5-Zimmer-Wohnung im Attikageschoss mit Ostausrichtung. Mit großer Terrasse von 43m².",
    features: ["Ostausrichtung", "Terrasse 43m²", "Tiefgarage", "Aufzug", "Glasfaser", "Attika"],
    images360: buildingImages,
    thumbnail: getProfileImage(22),
    floorPlan: `${cloudfrontUrl}/PDF-Grundrisse/Wohnung B4.2.pdf`,
    available: true,
    constructionYear: "Herbst 2027",
    heatingType: "Fernwärme",
    parking: true,
    balcony: false,
    elevator: true,
    floorPlanImages: generateFloorPlanImages(22)
  }
]; 
